import styled from '@emotion/styled'
import {
  InfoLarge500Style,
  InfoXXXLarge500Style,
  InfoMedium500Style,
} from '../../../../../styles/Text.styles'
import { css } from '@emotion/react'
import theme from '../../../../../styles/theme'

export const HeaderContainer = styled.div`
  background-color: ${`${theme.colors.primary}A0`};
  border-radius: 1rem;
  padding: 2rem 2rem 0rem 2rem;
  margin-bottom: 1rem;
`

export const ValueSymbolContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 0.6rem;
`

// Custom HStack component for horizontal stacking
export const HStack = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`

// Custom VStack component for vertical stacking
export const VStack = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`

export const WrapHStack = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  align-items: flex-start;
  width: 100%;
  margin-bottom: 3rem;
`

export const HeaderTop = styled(HStack)`
  justify-content: space-between;
  width: 100%;
  margin-bottom: 3rem;
`

export const LogoContainer = styled.div`
  max-height: 3rem;
  margin-right: 0.5rem;
  img {
    width: auto;
    height: 3rem;
    object-fit: contain;
  }
`

export const TitleContainer = styled.div`
  display: inline-flex; // Changed to inline-flex to fit content
  align-items: center;
  gap: 1rem;
  margin-bottom: 0; // Remove margin since HeaderTop handles spacing
  padding-left: 0.3rem;
  width: auto; // Allow container to shrink to content
  min-width: min-content; // Ensure it doesn't get smaller than content
`

export const ModelName = styled.p`
  ${InfoLarge500Style};
`

export const TitleText = styled.span`
  ${InfoXXXLarge500Style};
  display: inline-block; // Helps with proper sizing
`

export const ValueInfoBigStyle = css`
  ${InfoXXXLarge500Style};
`

export const ValueInfoNormalStyle = css`
  ${InfoLarge500Style};
  word-break: keep-all;
  overflow-wrap: normal;
`

export const ValueInfoMediumStyle = css`
  ${InfoMedium500Style};
  word-break: keep-all;
  overflow-wrap: normal;
`
